import lisaLandingVideo from '../LisaNormanLanding.mp4';
import { BRIDGE_HERO_VIDEO_URL } from '../../../siteConfig';
/**
 * The Bridge — assets in public/lisa/.
 * Hero video: drop `beach-sunrise.mp4` in public/lisa/ or set REACT_APP_HERO_VIDEO_URL.
 */
function getBase(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/lisa`;
  }
  return '/lisa';
}

const BASE = getBase();

const photoPath = (file: string) => `${BASE}/${encodeURIComponent(file)}`;

/** Optional public hero clip — falls back to bundled landing video */
function getHeroVideoSrc(): string {
  if (BRIDGE_HERO_VIDEO_URL) return BRIDGE_HERO_VIDEO_URL;
  return lisaLandingVideo;
}

/** Full lockup — icon + THE BRIDGE + tagline on beach (hero / footer) */
const LOGO_FULL = 'the-bridge-full-logo.png';
/** Bridge emblem — gradient icon only */
const LOGO_EMBLEM = 'the-bridge-logo-icon.png';
/** Legacy / reference assets in public/lisa/ */
const LOGO_EMBLEM_LEGACY = 'TheBridgeLogo.png';
const LOGO_FULL_GRADIENT = 'The bridge full gradient.png';
const LOGO_PLACEHOLDER = photoPath(LOGO_EMBLEM);

export const lnAssets = {
  base: BASE,
  path: (file: string) => `${BASE}/${encodeURIComponent(file)}`,
  logos: {
    /** Primary app logo — full wordmark lockup */
    full: photoPath(LOGO_FULL),
    /** Bridge emblem — icon only */
    emblem: photoPath(LOGO_EMBLEM),
    icon: photoPath(LOGO_EMBLEM),
    /** Reference / marketing PNGs */
    fullGradient: photoPath(LOGO_FULL_GRADIENT),
    emblemLegacy: photoPath(LOGO_EMBLEM_LEGACY),
    mark: photoPath(LOGO_EMBLEM),
    earth: LOGO_PLACEHOLDER,
    teal: LOGO_PLACEHOLDER,
    gold: LOGO_PLACEHOLDER,
    whiteTraced: LOGO_PLACEHOLDER,
    blackTraced: LOGO_PLACEHOLDER,
    whiteTracedPng: LOGO_PLACEHOLDER,
    blackTracedPng: LOGO_PLACEHOLDER,
  },
  photos: {
    /** Lisa Norman — About page hero portrait */
    lisaAboutHero: photoPath('lisa-about-hero.png'),
    /** Lisa Norman headshot — home Meet section */
    lisaPortrait: photoPath('lisa-portrait.png'),
    /** Salon / stylist era — About “My Journey” */
    lisaSalon: photoPath('lisa-salon.png'),
    /** Lisa with husband — About “Therapy Changed My Life Too” */
    lisaCouple: photoPath('lisa-couple.png'),
    /** Scenic bridge — About “Why The Bridge” */
    bridgeScenic: photoPath('about-bridge-scenic.png'),
    /** Services page hero — bridge at sunset (wide) */
    servicesHeroBridge: photoPath('services-hero-bridge.png'),
    /** Travel collage tiles — Beyond the Office */
    beyondTravel1: photoPath('about-travel-1.png'),
    beyondTravel2: photoPath('about-travel-2.png'),
    beyondTravel3: photoPath('about-travel-3.png'),
    beyondTravel4: photoPath('about-travel-4.png'),
    /** Who I Help — service area photos */
    whoHelpCouples: photoPath('who-help-couples.png'),
    whoHelpIndividual: photoPath('who-help-individual.png'),
    whoHelpFamily: photoPath('who-help-family.png'),
    whoHelpWorkshops: photoPath('who-help-workshops.png'),
    /** Bridge graphic — final CTA background (falls back to emblem) */
    aboutCtaBridge: photoPath('TheBridgeLogo.png'),
    thisIsUs: photoPath('placeholders/photo-founders-group.svg'),
    kironDani: photoPath('placeholders/photo-testimonial.svg'),
    troySolo: photoPath('placeholders/photo-portrait-male.svg'),
    sharreaSolo: photoPath('placeholders/photo-portrait-female.svg'),
    himHer: photoPath('placeholders/photo-couple-editorial.svg'),
    funPic1: photoPath('placeholders/photo-alt-couple.svg'),
    contactHero: photoPath('placeholders/photo-contact-hero.svg'),
  },
  /** Full-bleed ambient / landing loop — calm ocean at sunrise when beach clip is wired */
  videos: {
    landing: getHeroVideoSrc(),
  },
} as const;

/**
 * Normalize CMS media paths under `/lisa/` so filenames with spaces resolve reliably.
 */
export function resolvePublicMediaSrc(src: string): string {
  if (!src || typeof src !== 'string') return '';
  const t = src.trim();
  if (/^https?:\/\//i.test(t)) return t;

  const publicBase =
    typeof process !== 'undefined' && process.env.PUBLIC_URL !== undefined
      ? String(process.env.PUBLIC_URL).replace(/\/$/, '')
      : '';

  const m = t.match(/^\/?lisa\/(.+)$/i);
  if (m) {
    let name = m[1];
    try {
      name = decodeURIComponent(name);
    } catch {
      /* keep */
    }
    return `${publicBase}/lisa/${encodeURIComponent(name)}`;
  }

  if (t.startsWith('/')) return `${publicBase}${t}`;
  return `${publicBase}/${t}`;
}
